import { render, staticRenderFns } from "./PackageSaveShareOverlay.vue?vue&type=template&id=877db482&scoped=true&"
import script from "./PackageSaveShareOverlay.vue?vue&type=script&lang=js&"
export * from "./PackageSaveShareOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PackageSaveShareOverlay.vue?vue&type=style&index=0&id=877db482&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877db482",
  null
  
)

export default component.exports